import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Automation } from "../_types/automation";
import { Action } from "../_types/action";
@Injectable({
    providedIn: 'root',
})

export class ActionsService extends Service<Action> {
  public override type = 'actions';
  public override url = 'common/actions'; 

  getDropdownOptions(id: string, fieldName: string) {
    let url = this.getAPIUrl()+"/"+id+"/dropdownSqlOptions/"+fieldName;
    return this.http.post<any>(url, null);
  }  
  
}
